
const GetMyRISDropdownReducer = (state = { type: 'LOADING_MYRIS_DROPDOWN_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_MYRIS_DROPDOWN_ACTION':
            return action
        case 'RESET_MYRIS_DROPDOWN_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}

const GetMyRISDetailReducer = (state = { type: 'LOADING_MYRIS_DETAIL_VIEW_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_MYRIS_DETAIL_VIEW_ACTION':
            return action
        default:
            return state
    }
}
export {
    GetMyRISDropdownReducer,
    GetMyRISDetailReducer
}